export const LocalFeatureFlags = {
  ai_assistant: true,
  api_keys_dashboard: true,
  api_payload_export: true,
  brand_logos: false,
  catalog: true,
  decorator_profile: false,
  lifestyle_image: true,
  local_settings: true,
  logo_underbase: true,
  org_management: true,
  product_2d: true,
  use_stitches_decals: true,
  viewer_next: true,
};
